import './Logo.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class Logo extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        orientation: PropTypes.oneOf(['horizontal', 'stacked'])
    };

    render() {
        return (
            <div className={`c-logo ${this.props.className || ''}`}>
                {this.props.orientation === 'horizontal' ? (
                    <img src="/img/logo--horizontal.svg" alt="Zisk" />
                ) : (
                    <img src="/img/logo--stacked.svg" alt="Zisk" />
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Logo/index.js